import {
    IIconStyles, 
    ILabelStyles,
    mergeStyles,
    IStyle,
    IModalProps,
    IDragOptions,
    ContextualMenu,
    IDialogContentProps,
    DialogType
  } from 'office-ui-fabric-react';
import { AppLayoutSettings } from '../../pages/common.styles';
  

export const getDiamondIconStyles = (): IIconStyles => {
    return {
        root: {
            color: AppLayoutSettings.AppColors.wordBlue,
            fontSize: "20px",
        }
    };
};

export const getDialogContentProps = (title: string | JSX.Element, showCloseButton: boolean = false): IDialogContentProps => {
  return {
    type: DialogType.normal,
    showCloseButton,
    title
  }
};


export const getModalProps = (): IModalProps => {
  const dragOptions: IDragOptions = {
      moveMenuItemText: TranscriptionStrings.MoveLabel,
      closeMenuItemText: TranscriptionStrings.CloseLabel,
      menu: ContextualMenu,
  };
          
  return {
      isBlocking: true,
      styles: {
          root: getModalDialogStyles()
      },
      dragOptions
    }
};

export const getTopLabelStyles = (): ILabelStyles => {
    const commonLabelStyles = AppLayoutSettings.AppCommonStyles.getPageTopLabelStyles();
    const specificStyle: ILabelStyles = {
      root: {
        fontWeight: "bold"
      }
    };
  
    return {
      root: mergeStyles(commonLabelStyles.root, specificStyle.root)
    };
};

export const getModalDialogStyles = (): IStyle => {
    return {
        position: "initial"
    };
}